'use client';

import { createContext } from 'react';

/**
 * Whether what hosts a popover is on screen and holding still. A panel that
 * slides away provides false while it is hidden (or still sliding in), and
 * every popover inside it stays hidden too, so nothing points at a frame the
 * player can't see. True outside any such host.
 */
export const PopoverHostShownContext = createContext(true);
